module.exports = ".profile-image {\n    border-radius: 50%;\n    width: 125px;\n    height: 125px;\n}"